import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, ShoppingCart } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'ForceX Complete',
    path: '/products/forcex-complete'
  }, {
    name: 'ForceX DIY',
    path: '/products/forcex-diy'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Warranty',
    path: '/warranty'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b-4 border-brand-yellow" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="flex justify-between items-center h-20" data-id="element-55">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-56">
            <Link to="/" data-id="element-57">
              <img className="h-16 w-auto" src="https://cdn.magicpatterns.com/uploads/vAEpLiGwZwCFYgjmhhMBxx/precision_pro_sprayers_header_cropped.png" alt="Precision Pro Sprayers" data-id="element-58" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-59">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-bold uppercase tracking-wide hover:text-brand-yellow transition-colors ${isActive(link.path) ? 'text-brand-yellow' : 'text-brand-dark'}`} data-id="element-60">
                {link.name}
              </Link>)}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3" data-id="element-61">
            <button className="p-2 text-brand-dark hover:text-brand-yellow transition-colors relative" data-id="element-62">
              <ShoppingCart className="w-6 h-6" data-id="element-63" />
              <span className="absolute -top-1 -right-1 bg-brand-yellow text-brand-dark text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-64">
                0
              </span>
            </button>
            <Button variant="primary" size="sm" data-id="element-65">
              <Phone className="w-4 h-4 mr-2" data-id="element-66" />
              Call Now
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-3" data-id="element-67">
            <button className="p-2 text-brand-dark hover:text-brand-yellow transition-colors relative" data-id="element-68">
              <ShoppingCart className="w-6 h-6" data-id="element-69" />
              <span className="absolute -top-1 -right-1 bg-brand-yellow text-brand-dark text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-70">
                0
              </span>
            </button>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-brand-dark hover:text-brand-yellow focus:outline-none p-2" data-id="element-71">
              {isMenuOpen ? <X className="h-8 w-8" data-id="element-72" /> : <Menu className="h-8 w-8" data-id="element-73" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-74">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-75">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-4 rounded-md text-base font-bold uppercase ${isActive(link.path) ? 'bg-brand-light text-brand-yellow' : 'text-brand-dark hover:bg-gray-50 hover:text-brand-yellow'}`} onClick={() => setIsMenuOpen(false)} data-id="element-76">
                {link.name}
              </Link>)}
            <div className="px-3 py-4" data-id="element-77">
              <Button fullWidth variant="primary" data-id="element-78">
                <Phone className="w-4 h-4 mr-2" data-id="element-79" />
                Call Now
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}